import type { DisputesListRow } from "@/admin/entities/disputes";
import type { DisputesListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: DisputesListRow[];
  count: number;
} {
  const disputes = (data as DisputesListQueryType)?.disputes;
  if (!disputes || !disputes.nodes) {
    return { nodes: [], count: 0 };
  }
  return disputes;
}

export function mapColumns(dispute: DisputesListRow) {
  return [
    dispute.id,
    dispute.amount,
    dispute.amount.valueUSD,
    dispute.ottkitFeeAmount?.valueUSD,
    dispute.organizationAmount?.valueUSD,
    dispute,
    dispute,
    dispute,
    dispute,
    dispute.status,
    dispute,
    dispute.createdAt,
    dispute.closedAt,
  ];
}
